import { Component, OnInit, OnDestroy } from '@angular/core';
import { ValidateService } from '../../../../../@core/utils/validate.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ApiClientService } from '../../../../../@core/services';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ISubscription } from 'rxjs/Subscription';
import { IPMahakData } from '../models/ip-mahak-data';
import { ImprovementItem } from '../models';
import { ServicesHistoryervice } from '../../../../administaration/versions/services/serviceHistoryService';

@Component({
  selector: 'create-improvement-plan1',
  templateUrl: './mahak-improvement-plan.html',
  styleUrls: ['./mahak-improvement-plan.scss'],
  providers: [ValidateService],
})
export class MahakImprovementPlanComponent implements OnInit, OnDestroy {
  public data: IPMahakData;
  public dataLoaded: boolean = false;
  public fireValidationAlerts: boolean = false;
  public editable: boolean = false;
  public totalAchievement: boolean = false;
  finish: boolean = false;
  objId: number;
  objType: string;
  serviceHistoryObj: any;
  finishLoading: boolean;
  selectedreference2: any[] = [];
  constructor(
    private validationService: ValidateService,
    private route: ActivatedRoute,
    private router: Router,
    private apiClient: ApiClientService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private history: ServicesHistoryervice
  ) {
    this.valid = false;
  }

  ngOnInit() {
    this.objId = this.route.snapshot.params.id;
    this.objType = this.route.snapshot.params.type;

    this.initObject();

    this.initValidation();
    if (this.objId != null && this.objId !== 0)
      this.history.getById(this.objId).subscribe((res) => {
        this.serviceHistoryObj = res;
        this.finishLoading = true;
      });
  }

  initObject() {
    this.editable = true;

    this.data = {} as any;
    this.data.improvementPlan = {} as any;

    this.data.improvementPlan.processes = [{} as any];

    this.data.improvementPlan.improvementPriorities = [];
    this.data.improvementPriorities = [];
    this.finish = true;
    this.data.improvementPlan.objectId = this.objId;
    this.data.improvementPlan.objectType = this.objType;
  }

  loadData(formId: number) {
    this.apiClient.getData(`api/improvementPlan/mahak/${formId}`).subscribe((res: any) => {
      this.data = res;
      this.dataLoaded = true;
      if (!this.data.improvementPlan.processes) this.data.improvementPlan.processes = [{} as any];
      else if (this.data.improvementPlan.processes.some((x) => x.processAchievement !== null))
        this.totalAchievement = true;

      this.editable = this.data.improvementPlan.id > 0 && this.data.improvementPlan.approved !== false ? false : true;
    });
  }

  //#region Data Binding
  get_Inputs() {
    return this.data.improvementPlan && this.data.improvementPlan.inputs
      ? this.data.improvementPlan.inputs.map((x) => {
          return { id: x.id, value: x.name };
        })
      : [];
  }
  get_Outputs() {
    return this.data.improvementPlan && this.data.improvementPlan.outputs
      ? this.data.improvementPlan.outputs.map((x) => {
          return { id: x.id, value: x.name };
        })
      : [];
  }
  onChange_Inputs(data: any[]) {
    this.data.improvementPlan.inputs = data.map((x) => {
      return { id: x.id, name: x.value } as ImprovementItem;
    });
  }
  onChange_Outputs(data: any[]) {
    this.data.improvementPlan.outputs = data.map((x) => {
      return { id: x.id, name: x.value } as ImprovementItem;
    });
  }
  //#endregion

  //#region Validation
  private subscription: ISubscription;
  valid: boolean = false;
  processValid: boolean = false;

  initValidation() {
    this.validationService.registerForm(['name', 'goal', 'inputs', 'outputs', 'list']);

    // subscribe to the validation service's validStatus to update your local flag
    this.subscription = this.validationService.validStatus.subscribe((status) => {
      this.valid = status;
    });
  }

  isInputValid(name: string, status: boolean) {
    this.validationService.updateFormFlag(name, status);
  }

  ngOnDestroy() {
    // very important
    this.subscription.unsubscribe();
  }
  //#endregion

  save() {
    this.data.improvementPlan.processes.forEach((a) => {
      if (a.selectedRefernece != null && a.selectedRefernece.length > 0) {
        a.selectedRefernece.forEach((b) => {
          this.selectedreference2.push(b.id);
        });
      }
      a.selectedRefernece = this.selectedreference2;
      this.selectedreference2 = [];
    });
    console.log(this.data.improvementPlan);

    if (!this.valid) {
      this.fireValidationAlerts = false;

      this.apiClient.create(`improvementPlan/service`, this.data.improvementPlan).subscribe((res) => {
        this.router.navigate(['/admin/services-detail/' + this.serviceHistoryObj.serviceId]);
      });
    } else this.fireValidationAlerts = true;
  }

  confirmArchive() {
    this.apiClient.update(`api/improvementPlan/archive/${this.data.improvementPlan.id}`, null).subscribe((res) => {
      this.router.navigate(['/admin/filloutcriteria']);
    });
  }
  processAchievementRemember() {
    this.apiClient.update(`api/improvementPlan/sendRemember/${this.data.improvementPlan.id}`, null).subscribe((res) => {
      this.toastrService.success('تم إرسال رسائل التذكير');
    });
  }
  archivedPlans() {
    this.router.navigate([
      `/admin/improvementPlans/${this.data.improvementPlan.unitId}/${this.data.improvementPlan.mahakId}/mahak`,
    ]);
  }
  selectCompare(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id === o2.id : o2 === o2;
  }
}
